var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import styles from './historyFilters.module.scss';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var HistoryFilters = function (props) {
    var i18n = props.i18n, allFiltersHistory = props.allFiltersHistory, currentFilters = props.currentFilters, onFiltersChange = props.onFiltersChange;
    var handleFiltersChange = function (e, filter) {
        e.stopPropagation();
        var indexOfFilter = currentFilters.findIndex(function (flt) { return flt.type === filter.type; });
        if (indexOfFilter !== -1) {
            onFiltersChange(currentFilters.filter(function (flt) { return flt.type !== filter.type; }));
        }
        else {
            onFiltersChange(__spreadArray(__spreadArray([], currentFilters, true), [filter], false));
        }
    };
    var filterClassName = function (filter) {
        var _a;
        return classNames(styles.filtersListItem, (_a = {},
            _a[styles.filtersListItemActive] = currentFilters.findIndex(function (flt) { return flt.type === filter.type; }) !== -1,
            _a));
    };
    return (_jsx("section", __assign({ className: styles.historyFiltersWrapper }, { children: _jsx("ul", __assign({ className: styles.filtersList }, { children: allFiltersHistory.map(function (filter) {
                return (_jsxs("li", __assign({ className: filterClassName(filter), style: { backgroundColor: filter.color.backgroundColor }, onClick: function (e) { return handleFiltersChange(e, filter); } }, { children: [_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.RIGHT }, { children: getPropsByKeyPath(i18n.modules, filter.tooltipKeyPath) })), _jsx(Icons, { icon: filter.icon, color: filter.color.icon })] }), filter.type));
            }) })) })));
};
